const getPath = (obj, keys) => {
  if(!obj) return obj
  if(keys.length === 1) {
    let result = obj[keys[0]]
    //empty strings and zeros counts
    if (result === null || result === undefined) {
      //to handle HAVING better, try to match field ignoring whitespaces (e.g. COUNT ( Id ) === COUNT(Id) )
      let k = Object.keys(obj).find(k => k.replace(' ', '') === keys[0].replace(' ', ''))
      if (k) result = obj[k]
    }
    return result
  }
  return getPath(obj[keys[0]], keys.slice(1))
}

module.exports = getPath

